import { render, staticRenderFns } from "./paymentPeriodTable.vue?vue&type=template&id=132f2de6&scoped=true&lang=true"
import script from "./paymentPeriodTable.vue?vue&type=script&lang=js"
export * from "./paymentPeriodTable.vue?vue&type=script&lang=js"
import style0 from "./paymentPeriodTable.vue?vue&type=style&index=0&id=132f2de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f2de6",
  null
  
)

export default component.exports